function ucFirst(str) {
    if (!str) return str

    return str[0].toUpperCase() + str.slice(1)
}

export default class HideTransition {
    hiddenEl
    triggerEl
    property

    constructor(hiddenEl, triggerEl, property = 'height', transitionString) {
        this.hiddenEl = hiddenEl
        this.triggerEl = triggerEl
        this.property = property

        if (this.hiddenEl.hidden) {
            this.hideEl(this.hiddenEl, this.triggerEl)
        }

        this.hiddenEl.style.transition = transitionString || `${property} ease-in 0.2s`

        this.triggerEl.addEventListener('click', (e) => {
            this.hiddenEl.hidden ? this.showEl(this.hiddenEl, this.triggerEl) : this.hideEl(this.hiddenEl, this.triggerEl)
        })
        this.hiddenEl.addEventListener('transitionend', () => this.elTransitionEnd(this.hiddenEl))
    }

    hideEl = (element = this.hiddenEl, triggerElement = this.triggerEl) => {
        if (element.style[this.property] !== '0px') {
            element.style.overflow = 'hidden'
            element.style[this.property] = `${element[`scroll${ucFirst(this.property)}`]}px`
            window.getComputedStyle(element, null).getPropertyValue('width')
            element.style[this.property] = '0'
            triggerElement.classList.remove('active')
        }
    }
    showEl = (element = this.hiddenEl, triggerElement = this.triggerEl) => {
        if (element.style[this.property] === '0px' || !element.style[this.property]) {
            this.hiddenEl.hidden = false
            element.style.display = ''
            element.style[this.property] = `${element[`scroll${ucFirst(this.property)}`]}px`
            triggerElement.classList.add('active')
        }
    }
    elTransitionEnd = (element) => {
        if (element[`offset${ucFirst(this.property)}`] !== 0) {
            element.style[this.property] = ''
            element.style.overflow = ''
        } else {
            element.style.display = 'none'
            this.hiddenEl.hidden = true
        }
    }
}
